import {createTheme} from "@mui/material";

const theme = createTheme({
    // palette: {
    //     primary: {
    //         main: '#060229',
    //     }
    // },
})
export default theme;